// extracted by mini-css-extract-plugin
module.exports = {"Contact":"Contact_Contact__3XHjh","animate":"Contact_animate__3m8vJ","SocialIcon":"Contact_SocialIcon__pz2eg"};